import React, { useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import toast, { Toaster } from 'react-hot-toast'
import { FiChevronLeft, FiUploadCloud } from 'react-icons/fi'
import CarouselService from '../../service/CarouselService'
import '../styles/AdminForm.css'

const MAX_IMAGES = 10

const FormCarousel = () => {
  const navigate = useNavigate()
  const fileInputRef = useRef(null)
  const authorization = localStorage.getItem('token')

  const [images, setImages] = useState([])
  const [error, setError] = useState(null)
  const [submitting, setSubmitting] = useState(false)

  const addFiles = (fileList) => {
    const incoming = Array.from(fileList || []).filter((f) => f.type.startsWith('image/'))
    if (!incoming.length) return
    setImages((prev) => {
      const room = Math.max(0, MAX_IMAGES - prev.length)
      const accepted = incoming.slice(0, room).map((file) => ({ file, preview: URL.createObjectURL(file) }))
      return [...prev, ...accepted]
    })
    setError(null)
  }

  const handleDrop = (e) => {
    e.preventDefault()
    addFiles(e.dataTransfer.files)
  }

  const removeImage = (index) => {
    setImages((prev) => {
      const target = prev[index]
      if (target) URL.revokeObjectURL(target.preview)
      return prev.filter((_, i) => i !== index)
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (images.length === 0) {
      setError('Ajoutez au moins une image')
      document.querySelector('.ata-error')?.scrollIntoView({ behavior: 'smooth', block: 'center' })
      return
    }

    const formData = new FormData()
    for (const img of images) {
      formData.append('images', img.file)
    }

    setSubmitting(true)
    try {
      await CarouselService.ajouter(formData, authorization)
      toast.success('Images ajoutées avec succès')
      setTimeout(() => navigate('/admin/Carousel'), 800)
    } catch (err) {
      toast.error("Échec de l'ajout des images")
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <div className="ata-page">
      <Toaster />

      <div className="ata-header">
        <button type="button" className="ata-back" onClick={() => navigate('/admin/Carousel')}>
          <FiChevronLeft size={16} />
        </button>
        <div>
          <h1 className="ata-title">Ajouter au carousel</h1>
          <p className="ata-subtitle">Sélectionnez une ou plusieurs images pour le carousel de la page d'accueil</p>
        </div>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="ata-card" style={{ maxWidth: 640 }}>
          <div className="ata-card__label">
            Images du carousel
            {images.length > 0 && <span className="ata-card__count">{images.length}/{MAX_IMAGES}</span>}
          </div>

          <div
            className={`ata-dropzone ${error ? 'ata-dropzone--error' : ''}`}
            onDragOver={(e) => e.preventDefault()}
            onDrop={handleDrop}
            onClick={() => fileInputRef.current.click()}
          >
            <FiUploadCloud size={32} />
            <p className="ata-dropzone__text">Glisser-déposer ou <span>cliquer pour choisir</span></p>
            <p className="ata-dropzone__hint">JPG, PNG — jusqu'à {MAX_IMAGES} images</p>
            <input ref={fileInputRef} type="file" accept="image/*" multiple hidden onChange={(e) => addFiles(e.target.files)} />
          </div>

          {images.length > 0 && (
            <div className="ata-preview-grid">
              {images.map((img, i) => (
                <div className="ata-preview-item" key={i}>
                  <img src={img.preview} alt={`Aperçu ${i + 1}`} />
                  <button type="button" className="ata-preview-remove" onClick={() => removeImage(i)}>✕</button>
                </div>
              ))}
            </div>
          )}

          {error && <p className="ata-error">{error}</p>}
        </div>

        <div className="ata-footer-actions">
          <button type="button" className="ata-btn ata-btn--ghost" onClick={() => navigate('/admin/Carousel')}>Annuler</button>
          <button type="submit" className="ata-btn ata-btn--primary" disabled={submitting}>
            {submitting ? (<><span className="ata-spinner" /> Ajout…</>) : 'Ajouter les images'}
          </button>
        </div>
      </form>
    </div>
  )
}

export default FormCarousel
